import React from 'react';
import { Container } from 'react-bootstrap';
import AddCardForm from '../../components/AddCardForm/AddCardForm';
import ProfileCard from '../../components/ProfileCard/ProfileCard';


function AddCard(props) {
    const {orderId , bookingId} = props;
    return (
        <div className={'subPageContainer'}>
            <Container>
                <div className='subPageWrapper'>
                    <ProfileCard />
                    <AddCardForm orderId={orderId} bookingId={bookingId}/>
                </div>
            </Container>
        </div>
    )
}

export default AddCard